import type { DeliveryOrder } from '../types';

export const initialDeliveryOrders: DeliveryOrder[] = [
    {
        id: 'DEL-UBER-1',
        platform: 'Uber Eats',
        platformOrderId: 'UE-XYZ-123',
        customerName: 'Frank Green',
        items: [
            { name: 'Ribeye Steak (Medium Rare)', quantity: 1 },
            { name: 'French Fries', quantity: 1, specialInstructions: 'Extra crispy' },
            { name: 'Cola', quantity: 1 },
        ],
        status: 'new',
        timestamp: Date.now() - 60000 * 2, // 2 minutes ago
        deliveryAddress: '123 Queen Street, Auckland',
        estimatedDeliveryTime: Date.now() + 60000 * 25, // 25 minutes from now
    },
    {
        id: 'DEL-DOOR-1',
        platform: 'DoorDash',
        platformOrderId: 'DD-ABC-456',
        customerName: 'Grace Lee',
        items: [
            { name: 'Veggie Burger', quantity: 2, specialInstructions: 'No onions on one' },
            { name: 'Side Salad', quantity: 2 },
        ],
        status: 'new',
        timestamp: Date.now() - 60000 * 5, // 5 minutes ago
        deliveryAddress: '456 Cuba Street, Wellington',
        estimatedDeliveryTime: Date.now() + 60000 * 30, // 30 minutes from now
    },
    {
        id: 'DEL-UBER-2',
        platform: 'Uber Eats',
        platformOrderId: 'UE-LMN-789',
        customerName: 'Heidi Turner',
        items: [
            { name: 'Spaghetti Bolognese', quantity: 1 },
            { name: 'Garlic Bread', quantity: 1 },
        ],
        status: 'accepted',
        timestamp: Date.now() - 60000 * 15, // 15 minutes ago
        deliveryAddress: '789 Riccarton Road, Christchurch',
        estimatedDeliveryTime: Date.now() + 60000 * 10, // 10 minutes from now
    }
];